/* Larry's Tool Deals — Shopify theme scripts (cart count, AJAX add-to-cart, toast, mobile nav) */
(function () {
  var toastTimer;
  function showToast(msg, ok) {
    var t = document.getElementById("ltd-toast");
    if (!t) return;
    t.innerHTML = '<span class="ic">' + (ok === false ? "⚠" : "✔") + "</span> ";
    t.appendChild(document.createTextNode(msg));
    requestAnimationFrame(function () { t.classList.add("show"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2400);
  }

  function setCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? "grid" : "none";
    });
  }

  function refreshCount() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + "cart.js" : "/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); });
  }

  // AJAX add-to-cart on product cards and the product page (falls back to normal submit without JS)
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("form.ajax-add");
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var title = (btn && btn.dataset.title) || "item";
    if (btn) btn.disabled = true;
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : "/";
    fetch(root + "cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { showToast(res.body.description || res.body.message || "Could not add to cart", false); return; }
        showToast('Added "' + title + '" to cart');
        return refreshCount();
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  // Quantity +/- buttons on the product page
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-qty-step]");
    if (!b) return;
    var input = b.parentElement.querySelector("input[type=number]");
    if (!input) return;
    var v = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10);
    input.value = Math.max(parseInt(input.min || "1", 10), v);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  // Product page variant picker: keep hidden id, price and button in sync
  document.querySelectorAll("[data-variant-json]").forEach(function (script) {
    var variants = JSON.parse(script.textContent);
    var form = script.closest("form");
    var selects = form.querySelectorAll("[data-option-index]");
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[type="submit"]');
    var priceEl = document.querySelector("[data-pdp-price]");
    var oldEl = document.querySelector("[data-pdp-old]");
    var fmt = function (cents) { return "$" + (cents / 100).toFixed(2); };
    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!v) { btn.disabled = true; btn.textContent = "Unavailable"; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? "Add to Cart" : "Sold out";
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (oldEl) { oldEl.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : ""; }
      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      history.replaceState(null, "", url.toString());
    }
    selects.forEach(function (s) { s.addEventListener("change", update); });
  });

  // Product page thumbnails
  document.addEventListener("click", function (e) {
    var th = e.target.closest("[data-thumb-src]");
    if (!th) return;
    var main = document.getElementById("PdpMain");
    if (main) { main.src = th.dataset.thumbSrc; main.removeAttribute("srcset"); }
    document.querySelectorAll("[data-thumb-src]").forEach(function (x) { x.classList.toggle("active", x === th); });
  });

  // Mobile nav toggle
  var toggle = document.querySelector(".nav-toggle");
  var nav = document.querySelector(".site-nav .container");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  // Collection filters toggle (mobile) and auto-submit sort/filter forms
  var ft = document.querySelector(".filter-toggle-mobile");
  var filters = document.querySelector(".filters");
  if (ft && filters) ft.addEventListener("click", function () { filters.classList.toggle("open"); });
  document.querySelectorAll("[data-autosubmit]").forEach(function (el) {
    el.addEventListener("change", function () { el.form.submit(); });
  });
})();
